import { Routes } from '@angular/router';
//import { LoginComponent } from './pages/auth/login/login.component';
import { routeAlias } from '../routesalias';
import { DashboardComponent } from './pages/app/dashboard/dashboard.component';
import { ApplayoutComponent } from './components/layouts/applayout/applayout.component';
import { BudgetPage } from './pages/app/budgets/budget.component';
import { ActivityPage } from './pages/app/activities/activities.component';
import { MarchesPage } from './pages/app/marches/marches.component';
import { StructuresprogrammatiquesPage } from './pages/app/activities/structuresprogrammatiques/structuresprogrammatiques.component';
import { AddStructureProgrammatiquePage } from './pages/app/activities/structuresprogrammatiques/add/add.component';
import { TypeactivitiesPage } from './pages/app/parametres/activities/typeactivities/typeactivities.component';
import { ActivityChildPage } from './pages/app/activities/activity/activity.component';
import { AddActivityComponent } from './pages/app/activities/activity/add/add.component';
import { ModeexecutionComponent } from './pages/app/parametres/activities/modeexecution/modeexecution.component';
/* import { ActivitelayoutComponent } from './components/layouts/activitelayout/activitelayout.component'; */
import { ActivitiesComponent } from './pages/app/parametres/activities/activities.component';
import { AddTypeActivitePage } from './pages/app/parametres/activities/typeactivities/add/add.component';
import { TypeinterventionPage } from './pages/app/parametres/activities/typeintervention/typeintervention.component';
import { LignebudgetairePage } from './pages/app/parametres/activities/lignebudgetaire/lignebudgetaire.component';
import { AuthGuard } from './guards/auth.guard';
import { StructuresPage } from './pages/app/parametres/activities/structures/structures.component';
import { EditActivitiesPage } from './pages/app/parametres/activities/typeactivities/edit/edit.component';
import { MarchesLayoutComponent } from './pages/app/parametres/marches/marches.component';
import { FinancementPage } from './pages/app/parametres/marches/financement/financement.component';
import { ModepassationmarchePage } from './pages/app/parametres/marches/modepassationmarche/modepassationmarche.component';
import { AddModePassationmarchePageComponent } from './pages/app/parametres/marches/modepassationmarche/add/add.component';
import { ModepassationPageComponent } from './pages/app/parametres/marches/modepassation/modepassation.component';
import { TypemodepassationPageComponent } from './pages/app/parametres/marches/typemodepassation/typemodepassation.component';
import { EditModePassationMarchePage } from './pages/app/parametres/marches/modepassationmarche/edit/edit.component';
import { ExpressionBesoinHomePage } from './pages/app/marches/expression-besoin/expression-besoin.component';
import { AddExpressionBesoinPage } from './pages/app/marches/expression-besoin/add/add.component';
import { EditExpressionBesoinPage } from './pages/app/marches/expression-besoin/edit/edit.component';
import { RegroupementbesoinPage } from './pages/app/marches/regroupementbesoin/regroupementbesoin.component';
import { AddRegroupementExpressionBesoinPage } from './pages/app/marches/regroupementbesoin/add/add.component';
import { RegroupementactivitiesPage } from './pages/app/activities/regroupementactivities/regroupementactivities.component';
import { AddRegroupementActivitePage } from './pages/app/activities/regroupementactivities/add/add.component';
import { EditActivityPage } from './pages/app/activities/activity/edit/edit.component';
import { ParametresLayout } from './pages/app/parametres/parametres.component';
import { ThemeComponent } from './pages/app/theme/theme.component';
import { EditRegroupementExpressionBesoinPage } from './pages/app/marches/regroupementbesoin/edit/edit.component';
import { EditRegroupementActivity } from './pages/app/activities/regroupementactivities/edit/edit.component';
import { ComptabiliteLayout } from './pages/app/parametres/comptabilite/comptabilite.component';
import { ComptePage } from './pages/app/parametres/comptabilite/compte/compte.component';
import { TypecomptePage } from './pages/app/parametres/comptabilite/typecompte/typecompte.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { PostePages } from './pages/app/parametres/poste/poste.component';
import { AdministrationLayout } from './pages/app/administration/administration.component';
import { AgentPage } from './pages/app/administration/agent/agent.component';
import { AddAgentPage } from './pages/app/administration/agent/add/add.component';
import { EditAgentPage } from './pages/app/administration/agent/edit/edit.component';
import { UtilisateursCrudPage } from './pages/app/administration/utilisateurs/utilisateurs.component';

export const routes: Routes = [
    {
        path: "",
        component: ApplayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: routeAlias.home,
                component: DashboardComponent
            },
            {
                path: routeAlias.theme,
                component: ThemeComponent,
                canActivate: [AuthGuard]
            },
            {
                path: routeAlias.budgets.home,
                component: BudgetPage,
                canActivate: [AuthGuard],
                data: { roles: ['PPM', 'RA', 'COMPTABLE'] }
            },
            {
                path: routeAlias.activities.home,
                component: ActivityPage,
                canActivate: [AuthGuard],
                data: { roles: ['RA'] },
                children: [
                    {
                        path: "",
                        redirectTo: routeAlias.activities.structuresprogrammatiques.home,
                        pathMatch: "full"
                    },
                    {
                        path: routeAlias.activities.structuresprogrammatiques.home,
                        component: StructuresprogrammatiquesPage,
                        canActivate: [AuthGuard],
                        data: { roles: ['RA'] }
                    },
                    {
                        path: routeAlias.activities.activity.home,
                        children: [
                            {
                                path: "",
                                component: ActivityChildPage,
                                canActivate: [AuthGuard],
                                data: { roles: ['RA'] }
                            },
                            {
                                path: routeAlias.activities.activity.add,
                                component: AddActivityComponent,
                                canActivate: [AuthGuard],
                                data: { roles: ['RA'] }
                            },
                            {
                                path: `${routeAlias.activities.activity.edit}/:id`,
                                component: EditActivityPage
                            },
                            {
                                path: routeAlias.activities.activity.regroupement_activity.home,
                                children: [
                                    {
                                        path: "",
                                        component: RegroupementactivitiesPage
                                    },
                                    {
                                        path: routeAlias.activities.activity.regroupement_activity.add,
                                        component: AddRegroupementActivitePage
                                    },
                                    {
                                        path: `${routeAlias.activities.activity.regroupement_activity.edit}/:id`,
                                        component: EditRegroupementActivity
                                    },
                                ],
                            },
                        ]
                    },
                ]
            },

            /* Routes de marchés */
            {
                path: routeAlias.marchees.home,
                component: MarchesPage,
                children: [
                    {
                        path: "",
                        redirectTo: routeAlias.marchees.expression_besoin.home,
                        pathMatch: "full",
                    },
                    {
                        path: routeAlias.marchees.expression_besoin.home,
                        children: [
                            {
                                path: "",
                                component: ExpressionBesoinHomePage,
                            },
                            {
                                path: routeAlias.marchees.expression_besoin.add,
                                component: AddExpressionBesoinPage
                            },
                            {
                                path: `${routeAlias.marchees.expression_besoin.edit}/:id`,
                                component: EditExpressionBesoinPage
                            },
                            {
                                path: routeAlias.marchees.expression_besoin.regroupement_expression_besoin.home,
                                children: [
                                    {
                                        path: "",
                                        component: RegroupementbesoinPage
                                    },
                                    {
                                        path: routeAlias.marchees.expression_besoin.regroupement_expression_besoin.add,
                                        component: AddRegroupementExpressionBesoinPage
                                    },
                                    {
                                        path: `${routeAlias.marchees.expression_besoin.regroupement_expression_besoin.edit}/:id`,
                                        component: EditRegroupementExpressionBesoinPage
                                    },
                                ],
                            },
                        ]
                    },
                ]
            },

            /* Routes des parametres */
            {
                path: routeAlias.parameters.home,
                component: ParametresLayout,
                canActivate: [AuthGuard],
                data: { roles: ['SU', 'PRMP'] },
                children: [
                    {
                        path: '',
                        redirectTo: routeAlias.parameters.activity.home,
                        pathMatch: 'full'
                    },
                    /* Layout des activités */
                    {
                        path: routeAlias.parameters.activity.home,
                        component: ActivitiesComponent,
                        canActivate: [AuthGuard],
                        data: { roles: ['SU', 'PRMP'] },
                        children: [
                            {
                                path: "",
                                redirectTo: routeAlias.parameters.activity.type_activite.home,
                                pathMatch: "full"
                            },
                            {
                                path: routeAlias.parameters.activity.type_activite.home,
                                children: [
                                    {
                                        path: '',
                                        component: TypeactivitiesPage,
                                        canActivate: [AuthGuard],
                                        data: { roles: ['SU'] }
                                    },
                                    {
                                        path: routeAlias.parameters.activity.type_activite.add,
                                        component: AddTypeActivitePage,
                                        canActivate: [AuthGuard],
                                        data: { roles: ['SU'] }
                                    },
                                    {
                                        path: `${routeAlias.parameters.activity.type_activite.edit}/:id`,
                                        component: EditActivitiesPage,
                                        canActivate: [AuthGuard],
                                        data: { roles: ['SU'] }
                                    }
                                ]
                            },
                            {
                                path: routeAlias.parameters.activity.type_intervention.home,
                                component: TypeinterventionPage,
                                canActivate: [AuthGuard],
                                data: { roles: ['SU'] }
                            },
                            {
                                path: routeAlias.parameters.activity.ligne_budgetaire.home,
                                component: LignebudgetairePage,
                                canActivate: [AuthGuard],
                                data: { roles: ['SU'] }
                            },
                            {
                                path: routeAlias.parameters.activity.structure.home,
                                component: StructuresPage,
                                canActivate: [AuthGuard],
                                data: { roles: ['SU'] }
                            }
                        ]
                    },

                    //Marchés
                    {
                        path: routeAlias.parameters.marches.home,
                        component: MarchesLayoutComponent,
                        children: [
                            {
                                path: "",
                                redirectTo: routeAlias.parameters.marches.type_mode_passation.home,
                                pathMatch: "full"
                            },
                            //Financement
                            {
                                path: routeAlias.parameters.marches.financements.home,
                                // moved: FinancementPage is now exposed via top-level 'finance' route (COMPTABLE + SU)
                                component: FinancementPage,
                                canActivate: [AuthGuard],
                                data: { roles: ['PRMP', 'COMPTABLE'] }
                            },
                            //Mode de passation (opérationnel) -> PRMP + SU
                            {
                                path: routeAlias.parameters.marches.mode_passation.home,
                                component: ModepassationPageComponent,
                                canActivate: [AuthGuard],
                                data: { roles: ['PRMP'] }
                            },
                            //Type de mode de passation (référentiel) -> SU
                            {
                                path: routeAlias.parameters.marches.type_mode_passation.home,
                                component: TypemodepassationPageComponent,
                                canActivate: [AuthGuard],
                                data: { roles: ['PRMP'] }
                            },
                            //Mode de passation de marche
                            {
                                path: routeAlias.parameters.marches.mode_passation_marches.home,
                                children: [
                                    {
                                        path: '',
                                        component: ModepassationmarchePage,
                                        canActivate: [AuthGuard],
                                        data: { roles: ['PRMP'] }
                                    },
                                    {
                                        path: routeAlias.parameters.marches.mode_passation_marches.add,
                                        component: AddModePassationmarchePageComponent,
                                        canActivate: [AuthGuard],
                                        data: { roles: ['PRMP'] }
                                    },
                                    {
                                        path: `${routeAlias.parameters.marches.mode_passation_marches.edit}/:id`,
                                        component: EditModePassationMarchePage
                                    },
                                ]
                            }
                        ]
                    },

                    //Comptabilités
                    {
                        path: routeAlias.parameters.comptabilites.home,
                        component: ComptabiliteLayout,
                        canActivate: [AuthGuard],
                        data: { roles: ['COMPTABLE'] },
                        children: [
                            {
                                path: "",
                                redirectTo: routeAlias.parameters.comptabilites.typecompte.home,
                                pathMatch: "full"
                            },
                            {
                                path: routeAlias.parameters.comptabilites.compte.home,
                                component: ComptePage
                            },
                            {
                                path: routeAlias.parameters.comptabilites.typecompte.home,
                                component: TypecomptePage
                            }
                        ]
                    },
                    {
                        path: routeAlias.parameters.poste.home,
                        component: PostePages,
                    }
                    ,
                    {
                        path: routeAlias.parameters.poste.home,
                        component: PostePages,
                    }
                ]
            },

            /* Routes des administration */
            {
                path: routeAlias.administration.home,
                component: AdministrationLayout,
                canActivate: [AuthGuard],
                data: { roles: ['ADMIN'] },
                children: [
                    {
                        path: "",
                        redirectTo: routeAlias.administration.agent.home,
                        pathMatch: "full",
                    },
                    {
                        path: routeAlias.administration.agent.home,
                        children: [
                            {
                                path: "",
                                component: AgentPage,
                            },
                            {
                                path: routeAlias.administration.agent.add,
                                component: AddAgentPage
                            },
                            {
                                path: `${routeAlias.administration.agent.edit}/:id`,
                                component: EditAgentPage
                            },
                        ]
                    },
                    {
                        path: routeAlias.administration.utilisateur.home,
                        component: UtilisateursCrudPage
                    }
                ]
            },
        ]
    },

    /* Réserver à la page de connexion 
    {
        path: routeAlias.login,
        component: LoginComponent
    },
     {
        path: routeAlias.register,
        component: InscriptionPage
    } */
];
